var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              "Thanh toán phiếu thu học phí: " +
              _vm.orderCode +
              " " +
              _vm.titleInfoAdd,
            visible: _vm.dialogVisible,
            width: "1200px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "1vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "15px",
                display: "inline-block",
                position: "relative",
                "z-index": "1",
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  on: {
                    change: function ($event) {
                      return _vm.changeCategoryMethod()
                    },
                  },
                  model: {
                    value: _vm.dataSearch.category,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataSearch, "category", $$v)
                    },
                    expression: "dataSearch.category",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "both" } }, [
                    _vm._v("Tổng hợp"),
                  ]),
                  _c("el-radio", { attrs: { label: "in" } }, [_vm._v("Thu")]),
                  _c("el-radio", { attrs: { label: "out" } }, [_vm._v("Chi")]),
                ],
                1
              ),
            ],
            1
          ),
          _c("span", { staticStyle: { "margin-left": "745px" } }, [
            _vm._v("Số tiền tính toán:\n      "),
            _c("span", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v(_vm._s(_vm._f("formatCurrencyNew")(_vm.moneyCheckTotal))),
            ]),
          ]),
          _c(
            "el-table",
            {
              ref: "multipleTable",
              attrs: {
                "empty-text": _vm.textTable,
                "highlight-current-row": "",
                data: _vm.responseData.dataList,
                "cell-style": _vm.tableRowStyle,
                "header-cell-style": _vm.tableHeaderColor,
                "max-height": 320,
                border: "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  fixed: "",
                  label: "STT",
                  width: "50",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tên khoản",
                  prop: "fnPackage.name",
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "Loại", align: "center", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.fnPackage.category == "in"
                          ? _c("span", [_vm._v("Thu")])
                          : _vm._e(),
                        scope.row.fnPackage.category == "out"
                          ? _c("span", [_vm._v("Chi")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Trạng thái", align: "center", width: "95" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.paid == 0 && scope.row.money > 0
                          ? _c("span", [_vm._v("Chưa đóng")])
                          : scope.row.paid < scope.row.money
                          ? _c("span", [_vm._v("Thiếu")])
                          : _c("span", [_vm._v("Đủ")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Khóa", align: "center", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.locked
                          ? _c("span", [_vm._v("Đã khóa")])
                          : _c("span", [_vm._v("Chưa khóa")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Thành tiền", align: "right", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("formatCurrencyNew")(scope.row.money))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Đã trả", align: "right", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("formatCurrencyNew")(scope.row.paid))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Thiếu", align: "right", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatCurrencyNew")(
                                scope.row.money - scope.row.paid
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { fixed: "right", align: "center", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v("Tính toán")]),
                        _c("el-checkbox", {
                          on: {
                            change: function ($event) {
                              return _vm.checkRowMoneyAllMethod(scope.$index)
                            },
                          },
                          model: {
                            value: _vm.checkRowMoneyAll,
                            callback: function ($$v) {
                              _vm.checkRowMoneyAll = $$v
                            },
                            expression: "checkRowMoneyAll",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-checkbox", {
                          attrs: {
                            disabled:
                              scope.row.locked ||
                              Math.abs(scope.row.paid) >=
                                Math.abs(scope.row.money)
                                ? true
                                : false,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.checkedRowMoneyMethod()
                            },
                          },
                          model: {
                            value: scope.row.checkMoney,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "checkMoney", $$v)
                            },
                            expression: "scope.row.checkMoney",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { fixed: "right", align: "center", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v("Chọn khoản TT")]),
                        _c("el-checkbox", {
                          on: {
                            change: function ($event) {
                              return _vm.checkRowSchooseAllMethod(scope.$index)
                            },
                          },
                          model: {
                            value: _vm.checkRowSchooseAll,
                            callback: function ($$v) {
                              _vm.checkRowSchooseAll = $$v
                            },
                            expression: "checkRowSchooseAll",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-checkbox", {
                          attrs: {
                            disabled:
                              scope.row.locked ||
                              Math.abs(scope.row.paid) >=
                                Math.abs(scope.row.money)
                                ? true
                                : false,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.checkedRowMethod(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.checked,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "checked", $$v)
                            },
                            expression: "scope.row.checked",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("br"),
          this.dataSearch.category == "both" && !!this.responseData.description
            ? _c(
                "div",
                [
                  _c("el-checkbox", {
                    model: {
                      value: _vm.checkNotOrder,
                      callback: function ($$v) {
                        _vm.checkNotOrder = $$v
                      },
                      expression: "checkNotOrder",
                    },
                  }),
                  _vm._v(
                    "   In kèm ghi\n      chú:\n      " +
                      _vm._s(_vm.responseData.description) +
                      "\n    "
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-right": "15px" },
                      attrs: { span: 6 },
                    },
                    [
                      _c("div", {}, [
                        _vm.dataSearch.category == "in" ||
                        _vm.dataSearch.category == "both"
                          ? _c("div", { staticClass: "text-money" }, [
                              _vm._v(
                                "\n              Số dư ví\n              "
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    float: "right",
                                    color: "blue",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatCurrencyNew")(
                                          _vm.responseData.moneyWallet
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "text-money" }, [
                          _vm._v(
                            "\n              Tổng tiền phiếu thu\n              "
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                float: "right",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrencyNew")(
                                      _vm.responseData.moneyTotal
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "text-money" }, [
                          _vm._v(
                            "\n              Tổng tiền đã trả\n              "
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                float: "right",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrencyNew")(
                                      _vm.responseData.moneyTotalPaid
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "text-money" }, [
                          _vm._v(
                            "\n              Tiền còn lại phải trả\n              "
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                float: "right",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrencyNew")(
                                      _vm.responseData.moneyTotal -
                                        _vm.responseData.moneyTotalPaid
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("hr", {
                          staticStyle: {
                            "border-bottom": "1px solid #c0c4cc",
                            "margin-top": "-0.5em",
                            "margin-bottom": "0.7em",
                          },
                        }),
                        _c("div", { staticClass: "text-money" }, [
                          _vm._v(
                            "\n              Tổng tiền nhập\n              "
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                float: "right",
                                color: "yellow",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrencyNew")(
                                      _vm.dataInput.moneyInput +
                                        _vm.dataInput.moneyWallet
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "text-money" }, [
                          _vm._v(
                            "\n              Tiền các khoản đã chọn\n              "
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                float: "right",
                                color: "white",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrencyNew")(
                                      _vm.moneyPayment
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "text-money" }, [
                          _vm.dataInput.moneyInput +
                            _vm.dataInput.moneyWallet -
                            _vm.moneyPayment >
                          0
                            ? _c("span", [_c("span", [_vm._v("Tiền thừa")])])
                            : _c("span", [_vm._v(" Số tiền còn thiếu")]),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-weight": "bold",
                                float: "right",
                                color: "yellow",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrencyNew")(
                                      Math.abs(
                                        _vm.dataInput.moneyInput +
                                          _vm.dataInput.moneyWallet -
                                          _vm.moneyPayment
                                      )
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c(
                          "div",
                          { staticStyle: { "margin-bottom": "17px" } },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  color: "red",
                                },
                              },
                              [
                                _vm.dataSearch.category == "both" &&
                                _vm.dataInput.transferMoneyType == "MONEY_MONTH"
                                  ? _c("span", [
                                      _vm._v(
                                        "* Lưu ý: Số tiền thừa, thiếu sẽ được chuyển sang tháng tiếp\n                  theo"
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "* Lưu ý: Số tiền thừa của PHHS sẽ được chuyển vào ví"
                                      ),
                                    ]),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          [
                            _c("span", [_vm._v("QR thanh toán trực tuyến")]),
                            _vm.urlOnlinePayment !== null
                              ? _c("image-uploader", {
                                  staticStyle: { "margin-top": "20px" },
                                  attrs: {
                                    preview: _vm.urlOnlinePayment,
                                    placeholder: "QR thanh toán trực tuyến",
                                    updateAttendance: false,
                                  },
                                  model: {
                                    value: _vm.urlOnlinePayment,
                                    callback: function ($$v) {
                                      _vm.urlOnlinePayment = $$v
                                    },
                                    expression: "urlOnlinePayment",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-col",
                    { staticStyle: { float: "right" }, attrs: { span: 17 } },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "dataInput",
                          attrs: {
                            "label-width": "155px",
                            model: _vm.dataInput,
                            "label-position": "left",
                            rules: _vm.rules,
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "45%",
                              },
                              attrs: {
                                label: "Nhập số tiền",
                                prop: "moneyInput",
                              },
                            },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content:
                                      _vm.dataSearch.category === "out"
                                        ? "Nhập số tiền mặt nhà trường trả lại PHHS"
                                        : "Nhập số tiền mặt phụ huynh cần thanh toán",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("el-currency-input", {
                                    model: {
                                      value: _vm.dataInput.moneyInput,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dataInput,
                                          "moneyInput",
                                          $$v
                                        )
                                      },
                                      expression: "dataInput.moneyInput",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.dataSearch.category === "in" ||
                          _vm.dataSearch.category === "both"
                            ? _c(
                                "el-form-item",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "45%",
                                    float: "right",
                                  },
                                  attrs: {
                                    label: "Rút tiền trong ví",
                                    prop: "moneyWallet",
                                  },
                                },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content:
                                          "Nhập số tiền bạn muốn lấy ra từ Ví của PHHS",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("el-currency-input", {
                                        model: {
                                          value: _vm.dataInput.moneyWallet,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.dataInput,
                                              "moneyWallet",
                                              $$v
                                            )
                                          },
                                          expression: "dataInput.moneyWallet",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "el-form-item",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "45%",
                                    float: "right",
                                  },
                                  attrs: {
                                    label: "Chuyển tiền vào ví",
                                    prop: "walletStatus",
                                  },
                                },
                                [
                                  _c("el-checkbox", {
                                    staticStyle: { "line-height": "39px" },
                                    model: {
                                      value: _vm.dataInput.walletStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dataInput,
                                          "walletStatus",
                                          $$v
                                        )
                                      },
                                      expression: "dataInput.walletStatus",
                                    },
                                  }),
                                ],
                                1
                              ),
                          _c(
                            "span",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Hình thức thanh toán",
                                    prop: "paymentType",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.dataInput.paymentType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataInput,
                                            "paymentType",
                                            $$v
                                          )
                                        },
                                        expression: "dataInput.paymentType",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: { color: "black" },
                                          attrs: { label: "CASH" },
                                        },
                                        [_vm._v("Tiền mặt")]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: { color: "black" },
                                          attrs: { label: "TRANSFER" },
                                        },
                                        [_vm._v("Chuyển khoản")]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: { color: "black" },
                                          attrs: { label: "BOTH" },
                                        },
                                        [_vm._v("TM & CK")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    {
                                      style:
                                        _vm.dataInput.paymentType !== "BOTH"
                                          ? "margin-left: 20px; visibility: hidden"
                                          : "margin-left: 20px;",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  TM  \n                  "
                                      ),
                                      _c("el-currency-input", {
                                        staticStyle: { width: "125px" },
                                        attrs: { placeholder: "Tiền mặt" },
                                        model: {
                                          value: _vm.dataInput.moneyCash,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.dataInput,
                                              "moneyCash",
                                              $$v
                                            )
                                          },
                                          expression: "dataInput.moneyCash",
                                        },
                                      }),
                                      _vm._v(
                                        "\n                  CK\n                  "
                                      ),
                                      _c("el-currency-input", {
                                        staticStyle: {
                                          width: "125px",
                                          float: "right",
                                        },
                                        model: {
                                          value: _vm.dataInput.moneyTransfer,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.dataInput,
                                              "moneyTransfer",
                                              $$v
                                            )
                                          },
                                          expression: "dataInput.moneyTransfer",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "45%",
                              },
                              attrs: {
                                label: "Người thanh toán",
                                prop: "name",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    _vm.dataSearch.category === "out"
                                      ? "Nhà trường"
                                      : "Phụ huynh học sinh",
                                },
                                model: {
                                  value: _vm.dataInput.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataInput, "name", $$v)
                                  },
                                  expression: "dataInput.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "45%",
                                float: "right",
                              },
                              attrs: { label: "Ngày thanh toán", prop: "date" },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  clearable: false,
                                  "value-format": "yyyy-MM-dd",
                                  format: "dd-MM-yyyy",
                                  placeholder: "Chọn ngày",
                                  "picker-options": _vm.pickerOptions,
                                },
                                model: {
                                  value: _vm.dataInput.date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataInput, "date", $$v)
                                  },
                                  expression: "dataInput.date",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.dataSearch.category == "both"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Tiền thừa thiếu",
                                    prop: "transferMoneyType",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      staticStyle: { "margin-top": "12px" },
                                      model: {
                                        value: _vm.dataInput.transferMoneyType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataInput,
                                            "transferMoneyType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataInput.transferMoneyType",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: { color: "black" },
                                          attrs: { label: "MONEY_WALLET" },
                                        },
                                        [
                                          _vm._v(
                                            "Ví phụ huynh\n                "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: { color: "black" },
                                          attrs: { label: "MONEY_MONTH" },
                                        },
                                        [
                                          _vm._v(
                                            "Sang tháng sau\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Mô tả", prop: "description" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Nhập mô tả" },
                                model: {
                                  value: _vm.dataInput.description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataInput, "description", $$v)
                                  },
                                  expression: "dataInput.description",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _vm.activatedAccount
                                ? _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: _vm.dataInput.statusSendNotify,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataInput,
                                            "statusSendNotify",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataInput.statusSendNotify",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Gửi thông báo thanh toán trên App\n              "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { color: "#d13b93" } },
                                    [
                                      _vm._v(
                                        "Tài khoản chưa được kích hoạt, không thể gửi thông báo thanh toán App"
                                      ),
                                    ]
                                  ),
                            ],
                            1
                          ),
                          _c("br"),
                          _c("br"),
                          _vm.dataSearch.category == "both" &&
                          _vm.moneyPayment < 0
                            ? _c("el-form-item", [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "13px",
                                      color: "white",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                * Lưu ý: Tổng tiền các khoản đã chọn không được âm"
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.checkPermission(["electronic-invoice"])
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "warning",
                        size: "medium",
                        loading: _vm.loadingButton,
                        mini: "",
                      },
                      on: { click: _vm.handleOpenInvoiceDialog },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-check" }),
                      _c("span", [_vm._v("Lập HĐ điện tử")]),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "medium",
                    loading: _vm.loadingButton,
                    mini: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-check" }),
                  _c("span", [_vm._v("Thanh toán")]),
                ]
              ),
              _vm.dataSearch.category === "both"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "medium" },
                      on: { click: _vm.handleShowDialogConfigSize },
                    },
                    [
                      _c("i", { staticClass: "el-icon-printer" }),
                      _c("span", [_vm._v("In phiếu thu ")]),
                    ]
                  )
                : _vm._e(),
              _vm.dataSearch.category === "out"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "medium" },
                      on: { click: _vm.handleShowDialogConfigSize },
                    },
                    [
                      _c("i", { staticClass: "el-icon-printer" }),
                      _c("span", [_vm._v("In phiếu thu ")]),
                    ]
                  )
                : _vm._e(),
              _vm.dataSearch.category === "in"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "medium" },
                      on: { click: _vm.handleShowDialogConfigSize },
                    },
                    [
                      _c("i", { staticClass: "el-icon-printer" }),
                      _c("span", [_vm._v("In phiếu thu ")]),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", size: "medium" },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialog()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("button.close")))]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Thiết lập cỡ chữ file PDF",
            visible: _vm.dialogOptionsPdfVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogOptionsPdfVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { "background-color": "transparent" } },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", [_c("span", [_vm._v("Chọn cỡ chữ: ")])]),
              ]),
              _c(
                "el-col",
                { attrs: { span: 18 } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { placeholder: "Chọn cỡ chữ", size: "smail" },
                      model: {
                        value: _vm.fontSizePdf,
                        callback: function ($$v) {
                          _vm.fontSizePdf = $$v
                        },
                        expression: "fontSizePdf",
                      },
                    },
                    _vm._l(_vm.listFontSize, function (item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogOptionsPdfVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.loadingButtonPrint, type: "primary" },
                  on: { click: _vm.handleConfirmDownloadPdf },
                },
                [_vm._v("Xác nhận")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("OrderPrintDialog", {
        ref: "OrderPrintDialog",
        attrs: { dialogVisible: _vm.showOrderPrintDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeOrderPrintDialog()
          },
        },
      }),
      _c("OrderPrintOutDialog", {
        ref: "OrderPrintOutDialog",
        attrs: { dialogVisible: _vm.showOrderPrintOutDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeOrderPrintOutDialog()
          },
        },
      }),
      _c("OrderPrintInDialog", {
        ref: "OrderPrintInDialog",
        attrs: { dialogVisible: _vm.showOrderPrintInDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeOrderPrintInDialog()
          },
        },
      }),
      _c("InvoiceCreateDialog", {
        attrs: {
          isOpenInvoiceCreateDialog: _vm.isOpenInvoiceCreateDialog,
          initialItems: _vm.invoiceInitialItems,
          kidCode: _vm.invoiceKidCode,
          orderKidCode: _vm.invoiceOrderKidCode,
        },
        on: {
          "update:isOpenInvoiceCreateDialog": function ($event) {
            _vm.isOpenInvoiceCreateDialog = $event
          },
          "update:is-open-invoice-create-dialog": function ($event) {
            _vm.isOpenInvoiceCreateDialog = $event
          },
          "dialog-close": _vm.handleCloseInvoiceCreateDialog,
          back: _vm.handleCloseInvoiceCreateDialog,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }